<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Files log</h4>
                    </div>
                    
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-lg-8 col-md-7 col-sm-6 form-group">
                                    <button class="btn btn-success ml-1" @click="downloadCSV"> 
                                     CSV </button>
                                     <button class="btn btn-success ml-1" @click="downloadExcel"> 
                                    Excel </button>
                                    <button class="btn btn-success ml-1" @click="downloadPDF"> 
                                    PDF </button>
                                </div>
                                <div class="col-lg-4 col-md-5 col-sm-6 form-group" style="text-align: right">
                                    <input class="form-control" v-model="serverParams.customFilters.name" type="text"
                                        name="search" id="search" placeholder="Search" value="" @keyup="loadItems()">
                                </div>
                            </div>
                        </div>
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table
                        mode="remote"
                        :totalRows="totalRecords"
                        :isLoading="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPage: serverParams.perPage,
                            perPageDropdown: [10, 20, 50, 100, 200],
                        }"
                        :sort-options="{
                            enabled: true,
                            initialSortBy: {
                                field: 'UserID',
                                type: 'desc',
                            },
                        }"
                        :rows="rows"
                        :columns="columns"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'fileName'">
                                    <span>{{ props.row.name }} {{ props.row.lastName }}</span>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import moment from 'moment';
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; 

Vue.use(jsPDF)

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                customFilters: {
                    name: ''
                },
                sort: [
                    {
                        field: 'UserID', // example: 'name'
                        type: 'asc' // 'asc' or 'desc'
                    }
                ],

                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
            {
                    label: 'Practice Name',
                    field: "practiceName",
                    sortable: true,
                },
                {
                    label: 'First Name',
                    field: 'name',
                    filterable: false,
                    sortable: true,
                },
                {
                    label: 'Last Name',
                    field: 'lastName',
                    filterable: false,
                    sortable: true,
                },
                {
                    label: 'Material Name',
                    field: 'MaterialName',
                    filterable: false,
                    sortable: true,
                },
               
                {
                    label: 'Download Date',
                    field: "date",
                    sortable: true,
                    formatFn: this.formatDate
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
        };
    },
    methods: {
        downloadPDF() {
            // Fetch all data before exporting
            API.getFilesDownload({ ...this.serverParams, perPage: this.totalRecords },  // Fetch all records, not just the ones displayed
                data => {
                    const tableData = data.data.map(row => {
                        let rowData = {};
                        this.columns.forEach(column => {
                            if (column.field === 'fileName') {
                                rowData[column.label] = `${row.user.name} ${row.user.lastName}`;
                            } else {
                                rowData[column.label] = row[column.field];
                            }
                        });
                        return rowData;
                    });

                    const doc = new jsPDF();
                    doc.autoTable({
                        columns: this.columns.map(column => ({ header: column.label, dataKey: column.label })),
                        body: tableData
                    });
                    doc.text('Admin Systems | FileLog', 70, 10);
                    doc.save('Admin Systems FileLog.pdf');
                },
                err => {
                    console.error('Error fetching data for PDF export:', err);
                });
        },

        downloadExcel() {
            // Fetch all data before exporting
            API.getFilesDownload({ ...this.serverParams, perPage: this.totalRecords },  // Fetch all records, not just the ones displayed
                data => {
                    const tableData = data.data.map(row => {
                        let rowData = {};
                        this.columns.forEach(column => {
                            if (column.field === 'fileName') {
                                rowData[column.label] = `${row.user.name} ${row.user.lastName}`;
                            } else {
                                rowData[column.label] = row[column.field];
                            }
                        });
                        return rowData;
                    });

                    const XLSX = require('xlsx'); // Import XLSX library

                    const worksheet = XLSX.utils.json_to_sheet(tableData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

                    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const fileName = 'Admin Systems FileLog.xlsx';
                    if (navigator.msSaveBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        const link = document.createElement('a');
                        if (link.download !== undefined) {
                            const url = URL.createObjectURL(blob);
                            link.setAttribute('href', url);
                            link.setAttribute('download', fileName);
                            link.style.visibility = 'hidden';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);
                        }
                    }
                },
                err => {
                    console.error('Error fetching data for Excel export:', err);
                });
        },


        convertToCSV(data) {
            const csv = Papa.unparse(data);
            return csv;
        },
        downloadCSV() {
    // Fetch all data before exporting
        API.getFilesDownload({ ...this.serverParams, perPage: this.totalRecords },  // Fetch all records, not just the ones displayed
            data => {
                const tableData = data.data.map(row => {
                    let rowData = {};
                    this.columns.forEach(column => {
                        if (column.field === 'fileName') {
                            rowData[column.label] = `${row.user.name} ${row.user.lastName}`;
                        } else {
                            rowData[column.label] = row[column.field];
                        }
                    });
                    return rowData;
                });

                const csv = this.convertToCSV(tableData);

                const element = document.createElement('a');
                const file = new Blob([csv], { type: 'text/csv' });
                element.href = URL.createObjectURL(file);
                element.download = 'Admin Systems FileLog.csv';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            },
        err => {
            console.error('Error fetching data for CSV export:', err);
        });
        },
        loadItems() {
            this.isLoading = true;
            API.getFilesDownload(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                },
                err => {
                    this.isLoading = false;
                })
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        onSortChange(params) {
            Vue.set(this.serverParams.sort, 0, {
                field: params[0].field,
                type: params[0].type,
            });
            this.loadItems();
        },
            searchFn(params) {
                this.updateParams({
                    searchTerm: params
                });
                this.loadItems();
                this.isLoading = false;
            },

            formatStatus(status) {
                if (status === 1) {
                    return true;
                } else {
                    return false;
                }
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('YYYY-MM-DD')
                }
            },
    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
    }
}
</script>